import { jumpHistory, redo, undo } from '../../state/actions';
import { getHistoryView, useAppStore } from '../../state/store';
import { Icon } from '../components/controls';
import { Panel } from './Panel';

export function HistoryPanel() {
  const activeDocumentId = useAppStore((state) => state.activeDocumentId);
  const history = useAppStore((state) => getHistoryView(state, state.activeDocumentId));

  return (
    <Panel
      id="history"
      title="History"
      actions={
        <>
          <button
            type="button"
            className="button button--icon"
            title="Undo (Ctrl+Z)"
            disabled={!history.canUndo}
            onClick={undo}
          >
            <Icon size={14} path="M9 7L4 12l5 5M4 12h10a6 6 0 010 12h-2" />
          </button>
          <button
            type="button"
            className="button button--icon"
            title="Redo (Ctrl+Shift+Z)"
            disabled={!history.canRedo}
            onClick={redo}
          >
            <Icon size={14} path="M15 7l5 5-5 5M20 12H10a6 6 0 000 12h2" />
          </button>
        </>
      }
    >
      <div className="history-list">
        <button
          type="button"
          className={`history-item${history.position === -1 ? ' history-item--current' : ''}`}
          disabled={!activeDocumentId}
          onClick={() => jumpHistory(-1)}
        >
          Initial state
        </button>
        {history.labels.map((label, index) => (
          <button
            key={`${index}-${label}`}
            type="button"
            className={`history-item${
              index === history.position
                ? ' history-item--current'
                : index > history.position
                  ? ' history-item--future'
                  : ''
            }`}
            onClick={() => jumpHistory(index)}
          >
            {label}
          </button>
        ))}
      </div>
    </Panel>
  );
}
